package br.com.htms.inspeccaocampo.data

import br.com.htms.inspeccaocampo.platform.currentTimeMillis

/**
 * Checklist de controle de vetores e pragas em alojamentos.
 * Conforme e não conforme pedem foto; N/A pede justificativa.
 */
object ChecklistVetoresCatalog {
    const val TITULO = "Controle de vetores e pragas"
    const val SUBTITULO = "QSSMA – Inspeção de alojamentos | Frequência recomendada: semanal"

    val orientacoes: List<Pair<String, String>> = listOf(
        "Água parada" to "Eliminar o acúmulo e corrigir o ponto de retenção.",
        "Presença de roedores" to "Retirar fontes de alimento, vedar acessos e avaliar controle especializado.",
        "Presença de baratas" to "Higienizar o ambiente, eliminar fontes de alimento e avaliar desinsetização.",
        "Presença de escorpiões" to "Remover entulhos e abrigos, controlar insetos e acionar serviço especializado.",
        "Focos de mosquitos" to "Eliminar criadouros e realizar nova inspeção."
    )

    fun secoes(): List<SecaoConformidade> {
        var n = 0
        fun secao(titulo: String, vararg perguntas: String): SecaoConformidade {
            val itens = perguntas.map { pergunta ->
                n += 1
                ItemConformidade(
                    id = "vet_$n",
                    numero = n.toString(),
                    titulo = pergunta,
                    secao = titulo,
                    fotoHabilitada = true,
                    fotoObrigatoria = true
                )
            }
            return SecaoConformidade(titulo, itens)
        }
        return listOf(
            secao(
                "Área externa",
                "Terreno e áreas externas limpos e organizados.",
                "Ausência de água parada em recipientes, pneus, lonas e outros materiais.",
                "Calhas, ralos e canaletas limpos e desobstruídos.",
                "Vegetação aparada e sem acúmulo de folhas e materiais.",
                "Ausência de entulhos e materiais acumulados junto às paredes."
            ),
            secao(
                "Cozinha e refeitório",
                "Alimentos armazenados em recipientes fechados e protegidos.",
                "Lixeiras com tampa e em boas condições de higiene.",
                "Ausência de restos de alimentos expostos.",
                "Armários, bancadas e pisos limpos.",
                "Ausência de sinais de baratas, formigas, moscas ou roedores."
            ),
            secao(
                "Quartos e áreas comuns",
                "Quartos limpos, organizados e sem acúmulo de objetos.",
                "Ausência de frestas e possíveis abrigos de pragas.",
                "Ausência de sinais de roedores, baratas, aranhas ou escorpiões.",
                "Roupas e objetos pessoais armazenados adequadamente.",
                "Materiais sem uso e entulhos removidos."
            ),
            secao(
                "Banheiros e instalações",
                "Ralos limpos e protegidos, quando aplicável.",
                "Vasos sanitários, pias e chuveiros em boas condições.",
                "Ausência de vazamentos e pontos de umidade excessiva.",
                "Caixas de gordura e esgoto sem sinais de vazamento ou exposição.",
                "Caixas d'água tampadas e protegidas."
            ),
            secao(
                "Monitoramento e controle",
                "Não foram identificados focos de água parada ou criadouros de mosquitos.",
                "Não foram identificados fezes, ninhos ou roeduras de roedores.",
                "Não foram identificados focos ou sinais de infestação de insetos.",
                "Quando necessário, foi solicitado serviço especializado de controle de pragas.",
                "Os comprovantes dos serviços realizados estão arquivados.",
                "As ocorrências anteriores foram tratadas e as ações corretivas verificadas."
            )
        )
    }

    fun itens(): List<ItemConformidade> = secoes().flatMap { it.itens }

    fun novo(ms: Long = currentTimeMillis()): FormChecklistAlojamento =
        FormChecklistAlojamento(dataHorarioMs = ms, itens = itens())
}
